var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children, cloneElement } from "react";
import classNames from "classnames";
import AccordionContent from "./AccordionContent";
// styles
import "./accordion.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-accordion",
};
/**
 * An accordion is a vertical stack of interactive headings used to toggle the display of further information; each item can be 'collapsed' with just a short label visible or 'expanded' to show the full content.
 */
const Accordion = React.forwardRef((_a, ref) => {
    var { className, openPanels, children, onClick } = _a, rest = __rest(_a, ["className", "openPanels", "children", "onClick"]);
    const classList = classNames("tecma-accordion", className);
    return (_jsx("div", Object.assign({ ref: ref, className: classList }, rest, { children: Children.map(children, (child, index) => cloneElement(child, {
            open: Array.isArray(openPanels) ? openPanels === null || openPanels === void 0 ? void 0 : openPanels.includes(index) : openPanels === index,
            internalid: index,
            onClick: (e) => onClick && onClick(e, index),
        })) })));
});
Accordion.defaultProps = defaultProps;
const AccordionSpace = Object.assign(Accordion, {
    Content: AccordionContent,
});
export { AccordionSpace as Accordion };
